import { t } from 'i18next';
import z from 'zod';

export const vertragUpgradeFormSchema = z.object({
  telefon: z
    .string()
    .min(1, {
      message: t('domain.vertraege.kuendigenForm.fields.telefon.required'),
    })
    .regex(
      /^[^A-Za-z]*$/,
      t('domain.vertraege.kuendigenForm.fields.telefon.onlyNumbers'),
    ),
  beschreibung: z.string(),
});

export type FormSchema = z.infer<typeof vertragUpgradeFormSchema>;
